import React from 'react'
import { SearchAccountsResponsePayload } from '@Types'
import { formatFromAccount } from '../../utils/dataDisplayFormatters'
import { useIraConstraintsByMethod } from '../../api'
import CheckFormikWrapper from '../../components/CheckForm/CheckFormikWrap'
import isNull from 'lodash/isNull'

export interface CheckTransfersProps {
  account: SearchAccountsResponsePayload
  amountAvailable: number
  hasOvernightToApexPerm: boolean
  hasSubmitPermission: boolean
}

export default function CheckTransfers({
  account,
  amountAvailable,
  hasOvernightToApexPerm,
  hasSubmitPermission
}: CheckTransfersProps) {
  const { constraintData, constraintError } = useIraConstraintsByMethod(account.accountNumber, 'CHECK', 'WITHDRAWAL')
  const fromAccountDisplay = !isNull(amountAvailable)
    ? formatFromAccount(account.accountNumber, amountAvailable, account.accountTitle)
    : ''

  if (constraintError) {
    return <div>Error Loading IRA Constraints...</div>
  }

  if (constraintData) {
    return (
      <CheckFormikWrapper
        fromAccount={fromAccountDisplay}
        iraConstraintData={constraintData}
        account={account}
        amountAvailable={amountAvailable}
        hasOvernightToApexPerm={hasOvernightToApexPerm}
        hasSubmitPermission={hasSubmitPermission}
      />
    )
  }

  return <div>Loading...</div>
}
